import React from 'react';
import { FormattedMessage } from 'react-intl';
import MultiSelectOTA from '~/features/base/components/MultiSelectOTA';
import {
    useFetchVehicleEnergyTypesQuery,
    useFetchMmtHeadUnitsQuery,
    useFetchFunctionKeysQuery,
} from '~/api/mmt/MmtManagement.api';

interface MmtPropertiesDeliverablesFormItemProps {
    vehicleEnergyTypes?: string[];
    mmtHeadUnits?: string[];
    mmtFunctions?: string[];
    onChange: (values: {
        vehicleEnergyTypes?: string[];
        mmtHeadUnits?: string[];
        mmtFunctions?: string[];
    }) => void;
}

const MmtPropertiesDeliverablesFormItem: React.FC<MmtPropertiesDeliverablesFormItemProps> = ({
    vehicleEnergyTypes,
    mmtHeadUnits,
    mmtFunctions,
    onChange,
}) => {
    const { data: energyTypes = [] } = useFetchVehicleEnergyTypesQuery();
    const { data: headUnits = [] } = useFetchMmtHeadUnitsQuery();
    const { data: functionKeys = [] } = useFetchFunctionKeysQuery();

    const energyTypeOptions = energyTypes.map(type => ({ value: type, label: type, id: type }));
    const headUnitOptions = headUnits.map(unit => ({ value: unit, label: unit, id: unit }));
    const functionKeyOptions = functionKeys.map(key => ({ value: key, label: key, id: key }));

    return (
        <div className="margin-bottom-15">
            <div className={"margin-bottom-10"}><FormattedMessage id="intl-msg:mmtProperties" /></div>
            <div className={'display-flex gap-10'}>
                <div className='form-group width-50pct'>
                    <label><FormattedMessage id={'intl-msg:vehicleEnergyType'}/></label>
                    <MultiSelectOTA
                        value={vehicleEnergyTypes}
                        options={energyTypeOptions}
                        useClear
                        onChange={(value: any) => {
                            onChange({
                                vehicleEnergyTypes: value,
                                mmtHeadUnits,
                                mmtFunctions,
                            });
                        }}
                    />
                </div>
                <div className='form-group width-50pct'>
                    <label><FormattedMessage id={'intl-msg:mmtHeadUnit'}/></label>
                    <MultiSelectOTA
                        value={mmtHeadUnits}
                        options={headUnitOptions}
                        useClear
                        onChange={(value: any) => {
                            onChange({
                                vehicleEnergyTypes,
                                mmtHeadUnits: value,
                                mmtFunctions,
                            });
                        }}
                    />
                </div>
            </div>

            <div className='form-group'>
                <label><FormattedMessage id={'intl-msg:mmtFunctions'}/></label>
                <MultiSelectOTA
                    useClear
                    value={mmtFunctions}
                    options={functionKeyOptions}
                    onChange={(value: any) => {
                        onChange({
                            vehicleEnergyTypes,
                            mmtHeadUnits,
                            mmtFunctions: value?.length > 0 ? value : undefined,
                        });
                    }}
                />
            </div>
        </div>
    );
};

export default MmtPropertiesDeliverablesFormItem;
